import React, { ReactElement, useContext, useEffect } from 'react';
import { FilterContext } from 'components/filters/js/filter-service';
import { Spinner } from 'components/spinner/js/spinner';
import { NoResults } from 'components/filters/js/no-results';
import CardsLabels from './cards-labels';

const NewsList = (): ReactElement => {
    const { items, isLoading, itemsCount } = useContext(FilterContext);
    const num = itemsCount !== undefined ? itemsCount : 0;
    useEffect(() => {
        const cardsLabel = new CardsLabels();
        cardsLabel.init();
    });

    return isLoading || (num > 0 && !isLoading) ? (
        <section className="cards-grid spinner-placeholder">
            <Spinner isActive={isLoading} withOverlay={true} />
            <ul className="cards-grid__list" dangerouslySetInnerHTML={{ __html: items.join('') }} />
        </section>
    ) : (
        <NoResults />
    );
};

export { NewsList };
